import React from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { ALTER_ERROR, useSnackbar } from 'storfox-snackbar'
import { prop, propOr } from 'ramda'

import { DashboardLayout } from '~/components/Layouts'
import * as ROUTES from '~/constants/routes'
import * as NAV from '~/constants/nav-titles'
import ErrorLink from '~/components/ErrorLink'
import { INTEGRATION_TABS } from '~/constants/tabs'
import useMessages from '~/hooks/useMessages'

import {
  useIntegrationHistory,
  useShipRocketDetail,
  useShipRocketRemove,
  useShipRocketUpdate
} from '../../hooks'
import ShipRocketIntegrationUpdateForm from '../../components/ShipRocket/ShipRocketIntegrationUpdateForm'
import { ShipRocketUpdateSerializer } from '../../serializers'

function ShipRocketIntegrationUpdateContainer () {
  const { guid, tab } = useParams()

  const messages = useMessages()
  const snackbar = useSnackbar()
  const navigate = useNavigate()
  const integrationDetail = useShipRocketDetail(guid)
  const integrationUpdate = useShipRocketUpdate(guid)
  const integrationRemove = useShipRocketRemove()

  const title = prop('name', integrationDetail.detail)
  const type = propOr('', 'type', integrationDetail.detail)

  const detailPath = generatePath(ROUTES.INTEGRATION_UPDATE_PATH, { guid, type, tab: INTEGRATION_TABS.GENERAL })

  const historyAutoSend = Boolean(guid && tab === INTEGRATION_TABS.LOGS)
  const integrationHistory = useIntegrationHistory(guid, historyAutoSend)

  const handleSubmit = formValues =>
    integrationUpdate.update(ShipRocketUpdateSerializer(formValues))
      .then(() => {
        snackbar({ message: messages.UPDATE_SUCCESS })
        navigate(detailPath)
      })
      .catch(error => {
        const message = <ErrorLink error={error} />
        snackbar({ message, type: ALTER_ERROR })
      })

  const isLoading = (
    integrationDetail.isLoading ||
    integrationUpdate.isLoading
  )

  const handleRemove = () =>
    integrationRemove.delete({ guids: [guid] })
      .then(() => navigate(ROUTES.INTEGRATION_LIST_PATH, { replace: true }))

  const breadcrumbs = { title }

  return (
    <DashboardLayout
      isLoading={integrationDetail.isLoading}
      activeNav={NAV.INTEGRATION}
      breadcrumbs={breadcrumbs}
    >
      <ShipRocketIntegrationUpdateForm
        isLoading={isLoading}
        pageTitle={title}
        pageTitleLoading={integrationDetail.isLoading}
        onSubmit={handleSubmit}
        onRemove={handleRemove}
        initialValues={integrationDetail.detail}
        history={integrationHistory}
      />
    </DashboardLayout>
  )
}

export default ShipRocketIntegrationUpdateContainer
